import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuetify from 'vuetify'
import axios from 'axios'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import App from './App.vue'

import Index from '@/components/Index'
import People from '@/components/People'
import Publications from '@/components/Publications'
import Groups from '@/components/Groups'
import DemoRainbow from '@/components/DemoRainbow'

axios.defaults.baseURL = 'http://8.210.6.127:81/' // 'http://127.0.0.1:5000'
axios.defaults.withCredentials = true
Vue.use(VueRouter)
Vue.use(Vuetify)
Vue.prototype.$baseUrl = "http://8.210.6.127:81/" // 'http://127.0.0.1:5000'
Vue.prototype.$axios = axios
Vue.prototype.$color = {
  primary:'#575757',
  activate:"#657C88"
}
Vue.prototype.$window = window
Vue.config.productionTip = false

let router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component:Index
    },
    {
      path: '/index',
      name: 'Index',
      component:Index
    },
    {
      path: '/groups',
      name: 'Groups',
      component:Groups
    },
    {
      path: '/people',
      name: 'People',
      component:People
    },
    {
      path: '/publications',
      name: 'Publications',
      component:Publications
    },
    {
      path: '/demo/IRS',
      name: 'DemoRainbow',
      component:DemoRainbow
    }
    ]
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
